import type { LandingPageTemplateProps } from "../components/landing-page-template";
import logo from "../assets/logos/pegar-promo.jpg";

const config: LandingPageTemplateProps = {
  logo,
  gradient: "bg-gradient-to-b from-black/60 to-blue-900/60",
  header: "🎯 MELHORES PROMOÇÕES E CUPONS DIRETO NO SEU WHATSAPP",
  vip: ["🚨 GRUPO VIP 🚨", "100% GRATUITO"],
  discount: "OFERTAS com 50% 60% 70% OFF 🤝",
  waText: "GRUPO DO WHATSAPP",
  waHref: "https://linktr.it/pegar.promo",
  waLeftIcon: false,
  waRightIcon: true,
  tgEnabled: false,
  tgText: "CANAL DO TELEGRAM",
  tgHref: "https://t.me/pegarpromo",
  members: "⚡️ JÁ SOMOS +100 MIL MEMBROS ⚡️",
  footer: "Direitos Reservados",
  showJoinGroupHelp: false,
  logoClassName: "w-[150px] h-[150px]"
};

export default config;
